import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss'],
})
export class MediaComponent implements OnInit {
  lists = [1, 2, 3, 4, 5, 6];
  constructor() {}

  ngOnInit(): void {}
}
